const WHATSAPP_SEND_PATH = /^\/send(\/|$)/;

export function isWhatsAppChatLink(link) {
  try {
    const url = new URL(link.href);
    if (url.protocol !== 'https:') return false;
    if (url.hostname === 'wa.me') return true;
    return url.hostname === 'api.whatsapp.com' && WHATSAPP_SEND_PATH.test(url.pathname);
  } catch {
    return false;
  }
}

export function opensInNewTab(link, event) {
  return (
    String(link.target).toLowerCase() === '_blank' ||
    Boolean(event.metaKey || event.ctrlKey || event.shiftKey)
  );
}

function clickedLink(event) {
  const clicked = event.target;
  if (!clicked || typeof clicked.closest !== 'function') return null;
  return clicked.closest('a[href]');
}

function isNewTabWhatsAppClick(event) {
  const link = clickedLink(event);
  return Boolean(link && isWhatsAppChatLink(link) && opensInNewTab(link, event));
}

function isMovableNavigation(event) {
  return event.cancelable && !event.destination.sameDocument;
}

function openDetachedTab(win, url) {
  const tab = win.open(url, '_blank');
  if (!tab) return false;
  tab.opener = null;
  return true;
}

export function installNewTabRedirect({ win, defer }) {
  if (!win.navigation) return false;
  let pendingNewTab = false;

  win.addEventListener(
    'click',
    (event) => {
      pendingNewTab = isNewTabWhatsAppClick(event);
      if (pendingNewTab) defer(() => { pendingNewTab = false; });
    },
    true,
  );

  win.navigation.addEventListener('navigate', (event) => {
    if (!pendingNewTab || !isMovableNavigation(event)) return;
    pendingNewTab = false;
    if (openDetachedTab(win, event.destination.url)) event.preventDefault();
  });

  return true;
}

if (typeof window !== 'undefined') {
  installNewTabRedirect({ win: window, defer: (task) => window.setTimeout(task, 0) });
}
